<template>
  <div class="itw-input-container">
    <slot name="label">
      <span class="caption font-weight-medium" v-if="label">
        {{ label }} <span class="error--text" v-if="required">*</span>
      </span>
    </slot>
    <v-text-field
      v-model="model"
      :prepend-inner-icon="prependInnerIcon"
      :append-icon="appendIcon"
      :readonly="readonly"
      :disabled="disabled"
      :placeholder="placeholder"
      :persistent-hint="persistentHint"
      :suffix="suffix"
      :type="type"
      :hint="hint"
      :min="min"
      :max="max"
      :hide-details="hideDetails"
      :autocomplete="autocomplete"
      :autofocus="autofocus"
      :rules="rules"
      dense
      :class="color === 'white' ? 'custom-field-white' : 'custom-field'"
      solo
      flat
      filled
      @change="onChange"
      @click:append="$emit('appendIconClick')"
      :name="
        preventPrefill && (type === 'email' || type === 'password')
          ? `fake-${type}-${Math.random()}`
          : undefined
      "
    >
      <template v-slot:append v-if="append">
        <slot name="append"> </slot>
      </template>
    </v-text-field>
  </div>
</template>

<script>
import hasModel from "@/mixins/hasModel";

export default {
  mixins: [hasModel],
  props: {
    label: {
      type: String,
      required: false,
      default: "",
    },
    append: {
      type: Boolean,
      required: false,
      default: false,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      required: false,
      default: false,
    },
    persistentHint: {
      type: Boolean,
      required: false,
      default: false,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    rules: {
      type: Array,
      required: false,
      default: () => [],
    },
    prependInnerIcon: {
      required: false,
      type: String,
      default: undefined,
    },
    color: {
      type: String,
      required: false,
      default: "default",
    },
    appendIcon: {
      required: false,
      type: String,
      default: undefined,
    },
    hint: {
      type: String,
      required: false,
      default: "",
    },
    autocomplete: {
      type: String,
      required: false,
      default: "off",
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    preventPrefill: {
      type: Boolean,
      required: false,
      default: false,
    },
    autofocus: {
      type: Boolean,
      required: false,
      default: false,
    },
    type: {
      type: String,
      required: false,
      default: "text",
    },
    suffix: {
      type: String,
      required: false,
      default: "",
    },
    min: {
      type: [String, Number],
      required: false,
      default: "",
    },
    max: {
      type: [String, Number],
      required: false,
      default: "",
    },
  },
  methods: {
    onChange() {
      if (this.min) {
        this.model = Math.max(this.min, this.model);
      }
      this.$emit("change", this.model);
    },
  },
  watch: {
    model(newVal) {
      if (this.max && this.max < newVal) {
        this.$emit("input", this.max);
      }
    },
  },
};
</script>
